import { ESendMessageActionTypes } from '../../actions/sendMessage';
import { EUnreadMessagesCountActionTypes } from '../../actions/unreadMessagesCount';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function unreadMessagesCountReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EUnreadMessagesCountActionTypes.Set:
      return {
        ...state,
        unreadMessagesCount: action.payload,
      };

    case ESendMessageActionTypes.MarkMessageAsDeleted: {
      if (!action.payload.shouldDecreaseUnread) {
        return state;
      }

      const currentUnreadMessagesCount = state.unreadMessagesCount || 0;

      return {
        ...state,
        unreadMessagesCount: Math.max(0, currentUnreadMessagesCount - 1),
      };
    }

    case ESendMessageActionTypes.RestoreMessage: {
      if (!action.payload.shouldIncreaseUnread) {
        return state;
      }

      const currentUnreadMessagesCount = state.unreadMessagesCount || 0;

      return {
        ...state,
        unreadMessagesCount: currentUnreadMessagesCount + 1,
      };
    }

    default:
      return state;
  }
}
